// extracted by mini-css-extract-plugin
export default {"title":"PageTitle_title__su7+N"};